<script>
  import Tabs from '../layout/Tabs.svelte';
  import ComputerSummary from '../componentcontent/ComputerSummary.svelte';
  import ComputerResources from '../componentcontent/ComputerResources.svelte';
  import ComputerSoftware from '../componentcontent/ComputerSoftware.svelte';
  import ComputerAttributes from '../componentcontent/ComputerAttributes.svelte';
  import { selectedGroup } from '../store.js';
  import { Card, CardBody, CardHeader, CardTitle, Col, Row, ListGroup, ListGroupItem } from 'sveltestrap';
  import Tooltip from '../reusable components/tooltip.svelte';
  import getLastReportedColour from '../Helpers/LastReportedStateHelper'
  import { onMount } from 'svelte';
  import http from '../api/http.js';
  import ManagedEndpoint from '../pages/ComputerDashboard/Layout.svelte'
  export let vessel;  
  let computers = undefined;
  let selectedComputer;

     //tabs , 'Security'
  let tabs = ['Summary', 'Resources', 'Software', 'Attributes']
  let activeTab = 'Summary';
  let stateLegend = [
  {
    "name": "",
    "icon": "circle",
    "value": "Within last 24 hours.",
    "color": "info"
  },
  {
    "name": "",
    "icon": "circle",
    "value": "Over 24 hours ago.",
    "color": "warning"
  },
  {
    "name": "",
    "icon": "circle",
    "value": "Over 48 hours ago.",
    "color": "danger"
  }
];
let kioskStateLegend = [
  {
    "name": "",
    "icon": "desktop",
    "iconType": "fad",
    "value": "Kiosk.",
    "color": ""
  },
  {
    "name": "",
    "icon": "desktop",
    "iconType": "fad",
    "value": "Duplicate Kiosk.",
    "color": "danger"
  }
];
  const changeTab = (e) => {
    activeTab = e.detail;
  }

  let contentSize = () => {
    inner.style.height = '40%';    
  };

 async function getComputers(){
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/computers/${vessel.id}/${$selectedGroup}/vessel`);
    computers = await res.json();
    if(computers.length > 0){
        selectedComputer = computers[0];
    }
 }
</script>
<style>
    .systemsContent{

        height: 400px !important;
        max-height: 400px !important;
        overflow-y:auto;
    }
    
</style>

{#await getComputers()}
    <p>Loading computers.</p>
{:then}
    {#if computers.length < 1}
        <p>No computers found on vessel.</p>
    {/if}
    {#if computers.length > 0}
    <Row>
        <Col xs="4">
            <Card class="mb-4">
                <CardHeader class="card-header inline">
                        <CardTitle>
                            <h6 class="font-weight-bold" >Endpoints&nbsp;
                                <Tooltip content={kioskStateLegend} legend={true} title={"Kiosk States"}><i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip>
                            </h6>
                        </CardTitle>  
                </CardHeader>
                <CardBody>
                    <div class="systemsContent">
                        <ListGroup>
                            {#each computers as computer}
                                {#if selectedComputer === computer}
                                    {#if computer.operatingSystem != null}
                                        {#if computer.operatingSystem.toLowerCase().includes("windows")}
                                            <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} active tag="button" action>
                                                {#if (computer.kiosk) && (computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                                {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                                {/if}
                                                <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                                <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                                <i class="fab fa-windows fa-2x float-right"></i>
                                            </ListGroupItem>                        
                                        {:else}
                                            <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} active tag="button" action>
                                                {#if (computer.kiosk) && (computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                                {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                                {/if}
                                                <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                                <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                                <i class="fas fa-desktop fa-2x float-right"></i>
                                            </ListGroupItem>
                                        {/if}
                                    {:else}
                                        <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} active tag="button" action>
                                            {#if (computer.kiosk) && (computer.isDuplicate)}
                                                <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                            {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                            {/if}
                                            <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                            <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                            <i class="fas fa-desktop fa-2x float-right"></i>
                                        </ListGroupItem>
                                    {/if}                        
                                {:else}
                                    {#if computer.operatingSystem != null}
                                        {#if computer.operatingSystem.toLowerCase().includes("windows")}
                                            <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} tag="button" action>
                                                {#if (computer.kiosk) && (computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                                {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                                {/if}
                                                <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                                <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                                <i class="fab fa-windows fa-2x float-right"></i>
                                            </ListGroupItem>                        
                                        {:else}
                                            <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} tag="button" action>
                                                {#if (computer.kiosk) && (computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                                {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                    <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                                {/if}
                                                <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                                <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                                <i class="fas fa-desktop fa-2x float-right"></i>
                                            </ListGroupItem>
                                        {/if} 
                                    {:else}
                                        <ListGroupItem id="computer-selection-{computer.id}" on:click={() => selectedComputer = computer} tag="button" action>
                                            {#if (computer.kiosk) && (computer.isDuplicate)}
                                                <i class="fad fa-desktop fa-sm font-weight-normal text-danger"></i>
                                            {:else if (computer.kiosk) && !(computer.isDuplicate)}
                                                <i class="fad fa-desktop fa-sm font-weight-normal"></i>
                                            {/if}
                                            <i class="fad fa-circle text-{getLastReportedColour(computer.lastReportedState)}"></i>
                                            <span class="text-{getLastReportedColour(computer.lastReportedState)}">{computer.hostName}</span>
                                            <i class="fas fa-desktop fa-2x float-right"></i>
                                        </ListGroupItem>
                                    {/if}          
                                {/if}                    
                            {/each}
                        </ListGroup>
                    </div>
                </CardBody>
            </Card>
        </Col>
        <Col xs="8">
            <Card class="mb-4">                
                <CardBody>
                    <ManagedEndpoint computerId={selectedComputer.id} hostName={selectedComputer.hostName}></ManagedEndpoint>
                </CardBody>
            </Card>
        </Col>
    </Row>
    {/if}
{/await}